/** Chemins de navigation de l'objet Article (fiche par objet sur route). */

/** Base de la page "Configuration comptabilité". */
export const ARTICLE_ADMIN_BASE = '/admin/configuration-comptabilite';

/** Onglet du dashboard correspondant au listing des articles. */
export const ARTICLE_TAB = 'article';

/** Listing des articles (onglet du dashboard comptabilité). */
export const articleListPath = `${ARTICLE_ADMIN_BASE}?tab=${ARTICLE_TAB}`;

/** Fiche de création d'un article. */
export const articleCreatePath = `${ARTICLE_ADMIN_BASE}/article/new`;

/** Fiche d'édition d'un article. */
export const articleFichePath = (id: string | number): string =>
    `${ARTICLE_ADMIN_BASE}/article/${id}`;

/** Route enfant (relative à `admin/configuration-comptabilite`) : création (`new`) et édition (`:id`). */
export const ARTICLE_FICHE_ROUTE = 'article/:id';
